import { render, staticRenderFns } from "./modalMotivos.vue?vue&type=template&id=cdbdad9c"
import script from "./modalMotivos.vue?vue&type=script&lang=js"
export * from "./modalMotivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports